export default "هغه څنګه\nولې\nڅومره\nكله\nله کوم ځایه\nدی\nڅه\nڅه دي\nچیرته\nکوم چې\nکم یو\nتوپیر\nچا\nدي\nکوي\nوکړل\nلري\nکولی شي\nبه\nباید"